/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
export const siteConfig = {
    name: 'UdyamConnect.com',
    tagline: 'Verified Indian MSME Manufacturers & Wholesale Suppliers',
    description: 'Find verified Indian MSME manufacturers, exporters and wholesale suppliers. Compare GSTIN and Udyam-verified profiles, MOQs and request direct quotes on UdyamConnect.',
    // This is a CRA app: only NODE_ENV and REACT_APP_*-prefixed vars get
    // inlined at build time (see apiBase.js) — NEXT_PUBLIC_* is a Next.js
    // convention CRA never recognizes, so that env var was always undefined
    // and this constant silently shipped 'http://localhost:3000' to
    // production (visible in the JSON-LD Organization schema below).
    url: process.env.REACT_APP_SITE_URL || 'https://www.udyamconnect.com',
};
export const organizationJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: siteConfig.name,
    url: siteConfig.url,
    description: siteConfig.description,
};
